import React, { useCallback, useEffect,useState } from 'react'
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import { FaTrash } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import ModalUpdate from './ModalUpdate';
import axios from 'axios';
import Footer from './Footer';
import SearchBar from './SearchBar';


const Home = () => {

  const USER_API = "https://geektrust.s3-ap-southeast-1.amazonaws.com/adminui-problem/members.json";
  const ENTRIES_PER_PAGE = 10 ;

  const [users,setUsers] = useState([]);
  const [searchQuery,setSearchQuery] = useState("");
  const [filteredUsers,setFilteredUsers] = useState([]);
  const [userBeingUpdated,setUserBeingUpdated] = useState(null);
  const [selectedUsers,setSelectedUsers] = useState([]);
  const [isAllSelected,setIsAllSelected] = useState(false);
  const [curPage,setCurPage] = useState(1);
  const numberOfPages = Math.ceil(filteredUsers.length/ENTRIES_PER_PAGE);


// Fetch the complete userList on first mount
  useEffect(() => {

    const getUsersOnLoad = async () =>{

        try{
            const userResponse = await axios.get(USER_API);
            const userData = userResponse.data;
            setUsers(userData);
        }catch(e){
            console.log(e);
        }
    }

    getUsersOnLoad();

  },[])

// Get the filteredList by appying the current searchQuery on the updated master user list.
  useEffect(() =>{

    const usersFiltered = users.filter((user) => user.name.toLowerCase().includes(searchQuery.toLowerCase()) || user.email.includes(searchQuery.toLowerCase()) ||
    user.role.toLowerCase().includes(searchQuery.toLowerCase()));
    setFilteredUsers(usersFiltered);

  },[users,searchQuery])

// Updating the selected users based upon whether the select all checkbox is checkbox or not  
  useEffect(() =>{
    isAllSelected ? setSelectedUsers(getPaginatedUsers(curPage)) : setSelectedUsers([]);

  },[isAllSelected])

// On deletion or searching the length of filtered list can reduces thus changing the number of pages, so current page has to be updated to the last page in that case

  useEffect(()=>{   

    if(numberOfPages>0 && curPage > numberOfPages) setCurPage(numberOfPages);

 },[numberOfPages]);

//  Clear selected users on page change or change in number of Pages
 useEffect(()=>{
    setIsAllSelected(false);
 },[numberOfPages,curPage]);



//   The filtered users have to be further displayed page wise
  const getPaginatedUsers = (curPage) => {
    const startIndex = (curPage-1)*ENTRIES_PER_PAGE ;
    const endIndex = startIndex + ENTRIES_PER_PAGE ;
    const usersFilteredAndPaginated = filteredUsers.filter((user,index) => {

        return index >= startIndex && index < endIndex ;

    } )
    return usersFilteredAndPaginated ;
  } 


  
// modify master List of Users

  const deleteUser = (id) => {

    const newUsers = users.filter((user) => user.id !== id);
    setUsers(newUsers);

  }

  const updateUser = (id,updatedUser) =>{

    const newUsers = users.map(user =>{

        if(id === user.id)
        {
            return {id : user.id ,...updatedUser}
        }
        return user ;

    })
    setUsers(newUsers);
    setUserBeingUpdated(null);

  }



// modify Selected Users
  const updateSelectedUsers = (user) =>{

    if(selectedUsers.length > 0 && selectedUsers.findIndex(selectedUser => selectedUser.id === user.id) !== -1)
        {
            const newSelectedUsers = selectedUsers.filter((selectedUser) => selectedUser.id !== user.id);
            setSelectedUsers(newSelectedUsers);
        }
    else{
        const newSelectedUsers = [...selectedUsers];
        newSelectedUsers.push(user);
        setSelectedUsers(newSelectedUsers)
    }

  }

  const deleteSelectedUsers = () => {

    debugger
    const newUsers = users.filter(user =>{

        return selectedUsers.findIndex(selUser => selUser.id === user.id ) === -1 ;

    });
    setUsers(newUsers);
    setIsAllSelected(false);
  }



// Debouncing for limiting setQuery invocation 

  const debounce = (fn,delay) => {

    let timer ;

    return function(...args) {

        if(timer) clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this,args) , delay);

    }

  }

  const setQueryWithDebouncing = useCallback( debounce(setSearchQuery,500),[] );




// Pagination Controls

  const nextPage = () => { setCurPage((cur) => cur + 1) }

  const prevPage = () => { setCurPage((cur) => cur - 1) }

  const startPage = () => { setCurPage(1) }

  const endPage = () => { setCurPage(numberOfPages) }

  

// Display Table

  const UserTable = <Table 
                    size = "sm"
                    responsive>
                        <thead>
                            <tr>
                                <th>
                                    <div className="form-check">
                                        <input 
                                            className="form-check-input" 
                                            type="checkbox" 
                                            onChange={() => setIsAllSelected(!isAllSelected)}
                                            checked = {isAllSelected} />
                                    </div>
                                </th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Role</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                getPaginatedUsers(curPage).map(user => {

                                    return <tr 
                                            key={user.id}
                                            style={{
                                                backgroundColor : (selectedUsers.length > 0) && 
                                                selectedUsers.findIndex((selectedUser) => 
                                                 selectedUser.id === user.id 
                                                ) !== -1 ? 'lightGrey' : ""
                                            }}
                                            >
                                                <td>
                                                <div className="form-check">
                                                    <input 
                                                        className="form-check-input" 
                                                        type="checkbox" 
                                                        onChange={() => updateSelectedUsers(user)}
                                                        checked={(selectedUsers.length > 0) && 
                                                            selectedUsers.findIndex((selectedUser) => 
                                                             selectedUser.id === user.id 
                                                            ) !== -1
                                                        } />
                                                </div>
                                                </td>
                                                <td>{user.name}</td>
                                                <td>{user.email}</td>
                                                <td>{user.role}</td>
                                                <td className='table__user-actions'>
                                                    
                                                    <button
                                                        className='btn'
                                                        onClick={(e) => {
                                                                setUserBeingUpdated(user);
                                                            }
                                                        }>
                                                        <FaEdit size={20} />
                                                    </button>

                                                    <button
                                                        onClick={() => deleteUser(user.id)}
                                                        className='btn'>
                                                        <FaTrash/>
                                                    </button>

                                                </td>
                                            </tr>

                                })
                            }
                        </tbody>
                    </Table>
                                        
  

  

  return (
    <main className="container py-1 ">
        
        {/* 1 SearcBar */}
        <SearchBar handleInputChange = {setQueryWithDebouncing}/>

        {/* 2 UserTable*/}
        <div className='table-wrapper'>
            {UserTable}
        </div>
        
        {/* 3. ModalUpdatePopup */}
        {userBeingUpdated &&
            <ModalUpdate
                show={!!userBeingUpdated}
                currentUser = {userBeingUpdated}
                handleUpdate = {updateUser}
                onHide={setUserBeingUpdated}
            />
        }

        {/* 4. Footer */}
        <Footer
            currentPage={curPage}
            numberOfPages = {numberOfPages}
            handleCurrentPage = {setCurPage}
            handleDelete = {deleteSelectedUsers}
            handleNext = {nextPage}
            handlePrev = {prevPage}
            handleStart = {startPage}
            handleEnd = {endPage}
        />

    </main>
  )
}   

export default Home